// extracted by mini-css-extract-plugin
export default {"navContainer":"d2jzqFtiYhvWDupQu9rc","innerWrapper":"m29eUouv82TzWHG3b8Uw","tab":"bB_1qjBxAk1cpMVmEQYs","selected":"XVJekfeGX6JKay03cz26"};